import { createAction } from 'redux-actions'

const prefix = 'SUPER_MENU/'

export const setShowInterfaces = createAction(`${prefix}SET_SHOW_INTERFACES`)
export const setShowSuppliers = createAction(`${prefix}SET_SHOW_SUPPLIERS`)
export const setShowNewsIds = createAction(`${prefix}SET_SHOW_NEWS_IDS`)
